export const WEB_OAUTH_CLIENT = process.env.NEXT_PUBLIC_FORGEROCK_OAUTH_CLIENT;
export const APP_URL = process.env.NEXT_PUBLIC_BASE_URL;
export const LOGOUT_URL = process.env.NEXT_UAE_PASS_LOGOUT_URL;
export const AM_URL = process.env.NEXT_PUBLIC_FORGEROCK_AM_URL;
export const REALM_PATH = process.env.NEXT_PUBLIC_FORGEROCK_REALM_PATH;
export const JOURNEY_LOGIN_UAEPASS = process.env.NEXT_PUBLIC_FORGEROCK_JOURNEY_LOGIN_UAEPASS;
export const JOURNEY_LOGIN_EMAIL = process.env.NEXT_PUBLIC_FORGEROCK_JOURNEY_LOGIN_EMAIL;
export const SCOPE = process.env.NEXT_PUBLIC_FORGEROCK_SCOPE;
export const TIME_OUT = 120000; // Forgerock session API on logout takes around 1.5min, otherwise recommended API timeout is 5000 (5sec)
